module.exports = __webpack_public_path__ + "static/media/DoubleVanityFull_Web.20832a47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Mirrors/DoubleVanityFull_Web.jpg
// module id = 130
// module chunks = 0